import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="w-full py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-sm font-medium mb-4">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4 font-heading">
            50万+用户的选择与信赖
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            听听他们怎么说——来自真实用户的建站体验分享。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-primary-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-5">
                &ldquo;{t.content}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role} · {t.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}